import { OrderDirectionEnum } from 'generated/graphql';

export const sortingCategories = [
    { field: 'sortPriority', order: OrderDirectionEnum.Desc, viewValue: 'sort.popular' },
    { field: 'name.keyword', order: OrderDirectionEnum.Asc, viewValue: 'sort.name-asc' },
    { field: 'name.keyword', order: OrderDirectionEnum.Desc, viewValue: 'sort.name-desc' },
    { field: 'price', order: OrderDirectionEnum.Asc, viewValue: 'sort.price-asc' },
    { field: 'price', order: OrderDirectionEnum.Desc, viewValue: 'sort.price-desc' },
] as const;
